import {useEffect, useState, useCallback} from 'react';

export const useTimeout = (timeInMs: number): [boolean, () => void] => {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        let timeout = null;

        if (isActive) {
            timeout = setTimeout(() => {
                setIsActive(false);
            }, timeInMs);
        }

        return () => {
            if (timeout !== null) {
                clearTimeout(timeout);
                timeout = null;
            }
        }
    }, [isActive, setIsActive, timeInMs]);

    const start = useCallback(() => setIsActive(true), [setIsActive]);

    return [isActive, start];
}
